import React from 'react';
import ReactLoading from 'react-loading';
import AccountHolderInformationForm from '../AccountDetailForm/BasicInfo/AccountHolderInformationForm';
import AccountPICNumber from '../AccountDetailForm/PICNumber';
import WholesalerReseller from '../AccountDetailForm/WholesalerReseller';
import AccountAddress from '../AccountDetailForm/Address';
import AccountResellerAccountDeptForm from '../AccountDetailForm/BasicInfo/AccountResellerAccountDeptForm';
import AccountResellerPurchaseDeptForm from '../AccountDetailForm/BasicInfo/AccountResellerPurchaseDeptForm';
import AccountGovernmentDetailsForm from '../AccountDetailForm/BasicInfo/AccountGovernmentDetailsForm';
import AccountBankInformationForm from '../AccountDetailForm/BasicInfo/AccountBankInformationForm';
import AccountResellerPaymentMethodsForm from '../AccountDetailForm/BasicInfo/AccountResellerPaymentMethodsForm';
import AccountPasswordForm from '../AccountDetailForm/BasicInfo/AccountPasswordForm';
import AccountEmailForm from '../AccountDetailForm/BasicInfo/AccountEmailForm';

// import PropTypes from 'prop-types';

function Form(props) {
    const {
        globalConfig = {},
        initialized,
        isLoading,
        memberType,
        userInfo,
        submitAccountHolderInformation,
    } = props;
    const { createAddress, makeDefaultBillingAddress, deleteAddress } = props;
    const { createPICNumber, makeDefaultPICNumber, deletePICNumber } = props;
    const { deleteWholesalerReseller } = props;
    const { DisplayPaymentMethodSelector = false } = globalConfig;

    if (!initialized) {
        return (
            <React.Fragment>
                <div
                    className='card card--border'
                    style={{ position: 'relative', height: 200 }}
                >
                    <ReactLoading
                        className='button__spinner'
                        type='spin'
                        color='black'
                        height={50}
                        width={50}
                    />
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className='card card--border card--form card--stackable'>
                <AccountHolderInformationForm
                    {...props}
                    data={userInfo.basicInfo}
                    handleFormSubmission={submitAccountHolderInformation}
                />
            </div>
            <div className='card card--border card--form card--stackable'>
                <AccountPasswordForm
                    {...props}
                    data={userInfo.basicInfo}
                    handleFormSubmission={submitAccountHolderInformation}
                />
            </div>
            <div className='card card--border card--form card--stackable'>
                <AccountEmailForm
                    {...props}
                    data={userInfo.basicInfo}
                    handleFormSubmission={submitAccountHolderInformation}
                />
            </div>
            {/* Wholesaler means that it is editing reseller */}
            {memberType == 'reseller' && (
                <React.Fragment>
                    <div className='card card--border card--form card--stackable'>
                        <AccountResellerAccountDeptForm
                            {...props}
                            data={userInfo.basicInfo}
                            handleFormSubmission={
                                submitAccountHolderInformation
                            }
                        />
                    </div>
                    <div className='card card--border card--form card--stackable'>
                        <AccountResellerPurchaseDeptForm
                            {...props}
                            data={userInfo.basicInfo}
                            handleFormSubmission={
                                submitAccountHolderInformation
                            }
                        />
                    </div>
                    <div className='card card--border card--form card--stackable'>
                        <AccountGovernmentDetailsForm
                            {...props}
                            data={userInfo.basicInfo}
                            handleFormSubmission={
                                submitAccountHolderInformation
                            }
                        />
                    </div>
                    <div className='card card--border card--form card--stackable'>
                        <AccountBankInformationForm
                            {...props}
                            data={userInfo.basicInfo}
                            handleFormSubmission={
                                submitAccountHolderInformation
                            }
                        />
                    </div>
                    {DisplayPaymentMethodSelector === true && (
                        <div className='card card--border card--form card--stackable'>
                            <AccountResellerPaymentMethodsForm
                                {...props}
                                data={userInfo.basicInfo}
                                handleFormSubmission={submitAccountHolderInformation}
                            />
                        </div>
                    )}
                </React.Fragment>
            )}
            <div className='card card--border card--form card--stackable'>
                <AccountAddress
                    {...props}
                    isLoadingList={isLoading.addressList}
                    list={userInfo.availableAddresses.map((item) => {
                        return {
                            ...item,
                            CanDelete: !(
                                item.ID == userInfo.defaultDeliveryAddressID ||
                                (typeof userInfo.defaultBillingAddressID !=
                                    'undefined' &&
                                    item.ID == userInfo.defaultBillingAddressID)
                            ),
                            IsDelivery:
                                item.ID == userInfo.defaultDeliveryAddressID,
                            IsBilling:
                                item.ID == userInfo.defaultBillingAddressID,
                        };
                    })}
                    handleFormSubmission={createAddress}
                    handleMakeDefault={makeDefaultBillingAddress}
                    handleDelete={deleteAddress}
                />
            </div>
            {/*
            <div className='card card--border card--form card--stackable'>
                <WholesalerReseller
                    {...props}
                    isLoadingList={isLoading.wholesalerResellerList}
                    list={userInfo.availableWholesalerReseller.map((item) => {
                        return {
                            ...item,
                            CanDelete: !(
                                item.SupplierID == userInfo.selectedParentID
                            ),
                            IsDefault:
                                item.SupplierID == userInfo.selectedParentID,
                        };
                    })}
                    handleFormSubmission={() => {}}
                    handleMakeDefault={() => {}}
                    handleDelete={deleteWholesalerReseller}
                />
            </div>
            */}
            {(memberType !== 'retail-customer' && window.localeCountry === 'Australia') && (
                <div className='card card--border card--form card--stackable'>
                    <AccountPICNumber
                        {...props}
                        isLoadingList={isLoading.picNumberList}
                        list={userInfo.availablePICNumbers.map((item) => {
                            return {
                                ...item,
                                CanDelete: !(
                                    item.ID == userInfo.defaultPICNumberID
                                ),
                                IsDefault: item.ID == userInfo.defaultPICNumberID,
                            };
                        })}
                        handleFormSubmission={createPICNumber}
                        handleMakeDefault={makeDefaultPICNumber}
                        handleDelete={deletePICNumber}
                    />
                </div>
            )}
        </React.Fragment>
    );
}

export default Form;
